export default "__VITE_ASSET__7116cdfd__"